<div id="attractorLoop" *ngIf="tabIndex === 1 || tabIndex === 2">
  <div id="livePreview" class="live_preview">
    <!-- Load Video after user uploads -->
    <div id="videoPreviewMain" class="video_preview_main">
    <div id="videoPreviewPart" class="video_preview_part">
    <div id="videoPreview" class="video-preview" *ngIf="!(videoUrl && isVideoAvailable && isVideoFormat)">
      <img src="assets/images/video-icon-lg.png" alt="preview">
      <div id="videoPreviewLabel"><span class="video-preview-label" i18n="@@create-attractor-loop.video-preview-label">Upload a video to play during the Attract Loop.</span></div>
    </div>
    <div id="videoPreviewWOVideo" class="video-preview-withvideo" *ngIf="videoUrl && isVideoAvailable && isVideoFormat">
    <video class="video-area" #video  controls autoplay disablePictureInPicture
      controlsList="nofullscreen nodownload" [src]="videoUrl">
    </video>
    </div>
    </div>
    </div>
  </div>
  <div id="videoPreviewCaption" class="video_preview_caption">
    <span i18n="@@create-attractor-loop-oem.video.playback-attarct-loop-label">Your video will play during the <strong>Attract Loop</strong> on
      idle devices.</span>
  </div>
</div>
<ul *ngIf="(tabIndex === 1 || tabIndex === 2)" class="nav nav-tabs" role="tablist">
  <li class="nav-item">
    <a class="nav-link gtmAssetLibraryCreateAttractorLoopTitle" data-toggle="tab" [ngClass]="{'active': tabIndex === 1}">
      <span>{{editCheck ? selectedAttractorLoop.configurations.publishedName: newAttractVideoContentTitle}}</span></a>
  </li>
  <li class="nav-item exit_preview">
    <a class="nav-link gtmAssetLibraryCreateAttractorLoopCancel" (click)="cancel()">
      <img src="assets/images/exit_icon.svg" alt="exit without changes" />
    </a>
  </li>
</ul>
<div id="newLogoContent" class="tab-pane active">
  <div class="tab-content" id="newPromoTabs-content">
    <form [formGroup]="attractorLoopgrpForm">
      <div id="logoContentRow" class="row justify-content-start">
       <div id="logoContentCol" class="col-md-3">
        <div id="logoContentFormGroup" class="form-group">
          <label for="publishedName"><span i18n="@@global.tab-text.published-name">Published Name</span><span
              class="text-danger">*</span></label>
          <input type="text" class="form-control" id="publishedName" placeholder={{publishedNameplaceholder}}
            formControlName="publishedName" name="publishedName" maxlength="50" required />
          <div id="attractorLoopgrpFormErr" *ngIf="isSubmitted && attractorLoopgrpForm?.controls?.publishedName?.value.trim() === ''"
            class="formfield_err_msg"><span i18n="@@create-attractor-loop.form.required">This is a required field.</span>
          </div>
          <div id="attractorLoopgrpFormMaxErr" *ngIf="isSubmitted && attractorLoopgrpForm?.controls?.publishedName?.errors?.maxlength"
            class="formfield_err_msg"><span i18n="@@create-attractor-loop.form.published-name-50">Published name
            may be up to 50 characters long</span></div>
        </div>
        <div id="attractorLoopgrpInternal" class="form-group">
          <label for="internalName"><span i18n="@@global.tab-text.internal-name">Internal
              Name</span></label>
          <input type="text" class="form-control" id="internalName" placeholder={{internalNamePlaceholder}}
            formControlName="internalName" maxlength="50" />
        </div>
        </div>
        <div id="videoInputDiv" class="col-md-3 video-input-div">
        <div id="videoInputFrmGrp" class="form-group">
          <ng-template #popContent>
            <div id="popOver" class="popover-upload-req">
            <div id="popOverContent" class="d-flex align-items-center justify-content-center h-100">
              <img src="assets/images/video-icon.png" alt="video"/>
              <ul class="popOverList" [ngClass]="isImgVideoSizeInfoEnabled ? 'tooltip-list-style' : ''" >
                <li i18n="@@global.tooltip.video-rule-format">Video must be in <strong>MP4</strong> format</li>
                <li *ngIf="!isImgVideoSizeInfoEnabled" i18n="@@global.tooltip.video-rule-length">Allowed maximum length is <strong>60 seconds</strong></li>
                <li *ngIf="!isImgVideoSizeInfoEnabled" i18n="@@global.tooltip.video-max-size-error">Allowed maximum size is <strong>10 MB</strong></li>
              </ul>
            </div>
          </div>
        </ng-template>
          <label><span i18n="@@create-attractor-loop.images.attract">Attract Loop Video</span><span
              class="text-danger">*</span>
            <img class="info_icon" src="assets/images/info_circle_icon.svg" alt="hover for help"
              placement="left" [ngbPopover]="popContent" container="body" triggers="mouseenter:mouseleave" />
          </label>
          <div id="uploadButton">
            <label for="uploadedVideoName">
              <input #videoInput class="form-control" formControlName="uploadedVideoName" name="uploadedVideoName"
                id="uploadedVideoName" type="file" accept="video/mp4" (change)="readVideoUrl($event)" hidden>
              <video #video style="display: none;" *ngIf="videoUrl" controls [attr.src]="videoUrl"
                (loadedmetadata)="getDuration($event)">
              </video>
              <span class="btn btn-primary btn-sm left_icon_btn">
                <span class="upload-video_icon"></span>
                <span i18n="@@create-attractor-loop.images.upload">Upload Video</span></span>
            </label>
            <div id="fileNameContainer" class="file-name-container" *ngIf="isVideoAvailable && isVideoFormat">{{videoFileName}}</div>
            <div id="videoTypeErr" *ngIf="videoTypeError" class="uploadfile_err_msg"><span
                i18n="@@create-attractor-loop.videoTypeError.incorrect">Incorrect file type received.</span>
              <div id="videoTypeErrContent">
                <span i18n="@@global.tooltip.video-rule-format">Video must be in <strong>MP4</strong> format.</span>
              </div>
            </div>
            <div  id="videoLengthError" *ngIf="videoLengthError  && isVideoFormat" class="uploadfile_err_msg">
              <!-- TODO: Had a seperate span tag break here: Video must be. Removed for GLS work -->
              <span i18n="@@global.content-grp.video-duration-error">Video must be <strong>less than 60 seconds long.</strong></span>
            </div>
            <div id="videoSizeError" *ngIf="videoSizeError  && isVideoFormat" class="uploadfile_err_msg">
              <span i18n="@@global.content-grp.video-size-error">Video exceeds maximum size of <strong>10 MB.</strong></span>
          </div>
          </div>
        </div>
      </div>
    <div id="customDatePicker" class="col-md-3 date-picker-div" [ngClass] = "(isPublishDateCustomDatepicker || isExpiryDatePicker) ? 'time-picker-divsion' : ''">
      <div id="customDatePickerRow" class="row">
        <div id="customDatePickerCol" class="col-md-12">
          <label for="publishedTimeStamp"><span i18n="@@create-segments.form-group.publish-date-time">Publishing Date
              and Time</span></label>
          <div id="publishDateSection" class="publishDate-Section mb-2">
            <div id="customRadio" class="custom-radio mb-1">
              <input type="radio" name="publishdate" id="now" class="form-check-input" id="now"
                [checked]="!isPublishDateCustomDatepicker" (click)="selectCustomPublishDate('Now')" />
              <label for="now"><span i18n="@@create-segments.form-group.now">Now</span></label>
            </div>
            <div id="customDatePicker" class="custom-datepicker mt-1">
              <input type="radio" name="publishdate" id="publish-date-custom" class="form-check-input"
                id="publish-date-custom" [checked]="isPublishDateCustomDatepicker"
                (click)="selectCustomPublishDate('custom')" />
              <label for="publish-date-custom" *ngIf="!isPublishDateCustomDatepicker"><span
                  i18n="@@create-segments.form-group.custom">Custom</span></label>
              <div id="publishDateCustomDatepicker" *ngIf="isPublishDateCustomDatepicker">
                <iposcen-date-time-zone (errorMessageTime)="checkIfTimeset($event,'publish')"
                  (getDateTimeZoneData)="getLogoContentPublishDate($event)" (isTimeZoneSelected)="checkTimeZone($event,'publish')"
                  [publishDateInfo]="editPublishDateInfo" [divideDate]="divideDateFormat">
                </iposcen-date-time-zone>
              </div>
            </div>
          </div>
          <div id="publishingText" *ngIf="isCustomPublishDateCorrect || isCustomPublishTimeZoneSelected" class="formfield_err_msg"><span
              i18n="@@create-segments.form-group.publish-date-time-zone">Please select publishing date and time
              zone.</span>
          </div>
        </div>
      </div>
      <div class="row" id="publishedTimeStampRow">
        <div id="publishedTimeStampCol" class="col-md-12 expiry-div mt-2">
          <label for="publishedTimeStamp"><span i18n="@@create-segments.form-group.expiry-date-time">Expiration
              Date and Time</span></label>
          <div id="publishedTimeStampSection" class="publishDate-Section">
            <div id="publishedTimeStampCustomRadio" class="custom-radio mb-1">
              <input type="radio" name="expiryDate" id="never" class="form-check-input" id="never"
                [checked]="!isExpiryDatePicker" (click)="selectExpiryDateTimeZone('Never')" />
              <label for="never"><span i18n="@@create-segments.form-group.never">Never</span></label>
            </div>
            <div id="publishedTimeStampCustomeDatePicker" class="custom-datepicker mt-1">
              <input type="radio" name="expiryDate" id="expiry-custom" class="form-check-input" id="expiry-custom"
                [checked]="isExpiryDatePicker" (click)="selectExpiryDateTimeZone('custom')" />
              <label for="expiry-custom" *ngIf="!isExpiryDatePicker"><span
                  i18n="@@create-segments.form-group.custom">Custom</span></label>
              <div id="publishedTimeStampExpiryDate" *ngIf="isExpiryDatePicker">
                <iposcen-date-time-zone (errorMessageTime)="checkIfTimeset($event,'expiry')"
                  (getDateTimeZoneData)="getLogoContentExpiryDate($event)" (isTimeZoneSelected)="checkTimeZone($event,'expiry')"
                  [expiryDateInfo]="editexpiryDateInfo" [divideDate]="divideDateFormat">
                </iposcen-date-time-zone>
              </div>
            </div>
          </div>
        </div>
        <div id="expiredDateIncorrectErr" *ngIf="isExpiredDateIncorrect" class="formfield_err_msg errMsg"><span
            i18n="@@create-segments.form-group.less-than-publish-date">Expiration date should not be before publishing date.</span>
        </div>
        <div id="customExpiryDateCorrectErr" *ngIf="isCustomExpiryDateCorrect || isCustomExpiryTimeZoneSelected" class="formfield_err_msg errMsg"><span
            i18n="@@create-segments.form-group.expiry-date-time-zone">Please select expiration date and time
            zone.</span>
        </div>
      </div>
    </div>
      <div class="col-md-3 form-padding" id="applyContentCol" [ngClass] = "(isPublishDateCustomDatepicker || isExpiryDatePicker) ? 'form-divsion' : ''">
        <div id="applyContentFormGrp" class="form-group">
          <label for=""><span i18n="@@create-promo-content.apply-content-group-to-label">Apply content group to</span></label><br/>
          <button type="button" class="btn btn-primary left_icon_btn gtmFormFactorPromo" (click)="openFormFactorModal()">
            <img src="assets/images/laptop_icon.svg" alt="select form factors" />
            <span i18n="@@create-promo-content.select-form-factor">Select Form Factors</span>
          </button>
          <iposcen-form-factors #formFactorsModal [contentName]="formFactorSelectedAttract" 
            (applyFormFactor)="applyFormFactors($event)"></iposcen-form-factors>
          <div id="formFactorSelectedAttract" *ngIf="formFactorSelectedAttract" class="selected_factors">
            <div id="formFactorSelectedAttractSection">
              <div id="formFactorSelectedAttractSectionContent">
                <div id="deviceTypeAttract" class ="font-bold inline-block"><span >{{deviceTypeAttract}}</span>: </div>
                <div id="formFactorSelectedAttractDevices" class="inline">&nbsp;<span>{{ formFactorSelectedAttract?.devices}} </span></div>
              </div>
               <div id="formFactorManufactureqrAttractSection">
                <div id="manufacturerAttract" class ="font-bold inline-block"><span >{{manufacturerAttract}}</span>: </div>
                <div id="formFactorSelectedAttractManufacturer" class="inline"> &nbsp;<span>{{ formFactorSelectedAttract?.manufacturer}}</span></div></div>
              <div id="formFactorProcessorAttractSection">
                <div id="processorAttract" class ="font-bold inline-block"><span>{{processorAttract}}</span>: </div>
                <div id=" formFactorSelectedAttractProcessor" class="inline">&nbsp; <span>{{ formFactorSelectedAttract?.processors}} </span></div>
              </div>
              <div id="formFactorGenerationAttractSection">
                <div id= "generationAttract" class ="font-bold inline-block"><span >{{generationAttract}}</span>: </div>
                <div id="formFactorSelectedAttractgenerations"  class="inline">&nbsp;<span>{{ formFactorSelectedAttract?.generations}} </span></div>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div>
    </form>
  </div>
  <div class="button-wrapper" style="justify-content: flex-end">
    <button type="button" (click)="cancel()" class="btn btn-outline-primary gtmCancelUpldVdo">
      <span i18n="@@create-attractor-loop.newLogoContent.cancel">Cancel</span>
    </button>
    <button type="button" (click)="onAdd()" class="btn btn-primary gtmSaveUpldVdo"
      [disabled]="attractorLoopgrpForm?.controls?.publishedName?.value?.trim() === '' || !isVideoAvailable || !isVideoFormat">
      {{buttonLabel}}
    </button>
    <!--**TO DO**-->
    <iposcen-apply-changes-to-devices #applyModal (apply)="applyToDevice(true)" (closePopup)="applyToDevice(false)">
    </iposcen-apply-changes-to-devices>
  </div>
</div>
